import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { ENVIRONMENT } from '@app/constants/environment.token';

/**
 * Prepends the API base URL to every request that is not:
 * - A local asset (assets/)
 * - A Vimeo CDN call
 * - Already an absolute URL
 */
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
    const env = inject(ENVIRONMENT);

    const isAsset = req.url.startsWith('assets/') || req.url.startsWith('/assets/');
    const isVimeo = req.url.includes('player.vimeo') || req.url.includes('vimeocdn');
    const isAbsolute = req.url.startsWith('http://') || req.url.startsWith('https://');

    if (isAsset || isVimeo || isAbsolute) {
        return next(req);
    }

    const apiReq = req.clone({ url: `${env.apiUrl}${req.url}` });
    return next(apiReq);
};
